<template>
  <div>
    <h1>Detalle de Pagos (con contratos)</h1>
    <!-- Botón ojito -->
    <br>
    <vs-button type="flat" class="p-2" icon-pack="fa" :icon="showTable ? 'fa-eye-slash' : 'fa-eye'"
      @click="showTable = !showTable"
      color="primary"
      title="Mostrar/Ocultar tabla">
    </vs-button>
    <br>
    <div >
      <!--boton para cargar reporte de pagos-->
      <vs-button @click="getReporte" class="p-2" color="primary" icon="refresh">
        Cargar Reporte
      </vs-button>
      <div>
        <div class="vx-row mt-3">
          <!-- Totales principales -->
          <div class="vx-col w-full mb-6">
            <p class="text-center text-2xl">Total pagos cerrados y sin cerrar: {{ (totalPagos + totalPagosCerrar) | filtrarDecimal }}</p>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">

              <!-- Total Pagos -->
              <div class="flex flex-col items-center justify-center bg-white border rounded-lg shadow p-6">
                <h3 class="text-sm text-gray-500">Total Pagos cerrados</h3>
                <p class="text-4xl font-bold text-gray-800 mt-2" v-if="totalPagos > 0 || totalPagosCerrar > 0">
                  {{ totalPagos | filtrarDecimal }}
                </p>
              </div>

              <!-- Pagos sin cerrar -->
              <div class="flex flex-col items-center justify-center bg-white border rounded-lg shadow p-6">
                <h3 class="text-sm text-gray-500">Pagos sin cerrar</h3>
                <p class="text-4xl font-bold text-red-600 mt-2" v-if="totalPagos > 0 || totalPagosCerrar > 0">
                  {{ totalPagosCerrar | filtrarDecimal }}
                </p>
              </div>

            </div>
          </div>
          <!-- Tabla detalle -->
          <div class="vx-col w-full" v-if="(totalPagos > 0 || totalPagosCerrar > 0) && (showTable)">
            <table class="table-auto border-collapse border border-gray-300 w-full text-base">
              <thead>
                <tr class="bg-gray-100 text-center font-semibold text-gray-700">
                  <th class="border border-gray-300 px-4 py-2 text-lg">Cerrados</th>
                  <th class="border border-gray-300 px-4 py-2 text-lg">Sin Cerrar</th>
                  <th class="border border-gray-300 px-4 py-2 text-lg">Totales</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <!-- Cerrados -->
                  <td class="border border-gray-300 px-4 py-2 align-top text-lg">
                    <b class="text-lg">Total Anticipos:</b>
                    <p class="text-lg">{{ datosReport.totalAnticipos | filtrarDecimal }}</p>
                    <b class="text-lg">Total Liquidaciones:</b>
                    <p class="text-lg">{{ datosReport.totalLiquidaciones | filtrarDecimal }}</p>
                    <b class="text-lg">Total Otros Valores:</b>
                    <p class="text-lg">{{ datosReport.totalOtrosValores | filtrarDecimal }}</p>
                    <b class="text-lg">Total Convenio Detalle aprobados:</b>
                    <p class="text-lg">{{ datosReport.totalConvenio | filtrarDecimal }}</p>
                    <b class="text-lg">Total Anticipo Pedido:</b>
                    <p class="text-lg">{{ datosReport.totalAnticipoAprobado | filtrarDecimal }}</p>
                  </td>

                  <!-- Sin Cerrar -->
                  <td class="border border-gray-300 px-4 py-2 align-top text-lg">
                    <b class="text-lg">Total Anticipos:</b>
                    <p class="text-lg">{{ datosReport.totalAnticiposSinCerrar | filtrarDecimal }}</p>
                    <b class="text-lg">Total Liquidaciones:</b>
                    <p class="text-lg">{{ datosReport.totalLiquidacionesSinCerrar | filtrarDecimal }}</p>
                    <b class="text-lg">Total Otros Valores:</b>
                    <p class="text-lg">{{ datosReport.totalOtrosValoresSinCerrar | filtrarDecimal }}</p>
                    <b class="text-lg">Total Convenio Detalles sin aprobar:</b>
                    <p class="text-lg">{{ datosReport.totalConvenioSinCerrar | filtrarDecimal }}</p>
                    <b class="text-lg">Total Anticipo Pedido:</b>
                    <p class="text-lg">{{ datosReport.totalAnticipoAprobadoSinCerrar | filtrarDecimal }}</p>
                  </td>

                  <!-- Totales -->
                  <td class="border border-gray-300 px-4 py-2 align-top font-semibold text-lg">
                    <b class="text-lg">Total Anticipos:</b>
                    <p class="text-lg">{{ (datosReport.totalAnticipos + datosReport.totalAnticiposSinCerrar) | filtrarDecimal }}</p>
                    <b class="text-lg">Total Liquidaciones:</b>
                    <p class="text-lg">{{ (datosReport.totalLiquidaciones + datosReport.totalLiquidacionesSinCerrar) | filtrarDecimal }}</p>
                    <b class="text-lg">Total Otros Valores:</b>
                    <p class="text-lg">{{ (datosReport.totalOtrosValores + datosReport.totalOtrosValoresSinCerrar) | filtrarDecimal }}</p>
                    <b class="text-lg">Total Convenio :</b>
                    <p class="text-lg">{{ (datosReport.totalConvenio + datosReport.totalConvenioSinCerrar) | filtrarDecimal }}</p>
                    <b class="text-lg">Total Anticipo Pedido:</b>
                    <p class="text-lg">{{ (datosReport.totalAnticipoAprobado + datosReport.totalAnticipoAprobadoSinCerrar) | filtrarDecimal }}</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- Botón para ver detalles -->
            <div class="flex justify-center">
              <vs-button class="p-2" color="dark" @click="popupMostrarDetalles=true;"><i class="fa-solid fa-file-lines"></i> Detalles pagos</vs-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--modales-->
    <!--modal para mostrar detalle-->
    <vs-popup classContent="popup-example" fullscreen title="Detalle pagos" :active.sync="popupMostrarDetalles">
      <div v-if="popupMostrarDetalles">
        <ReportePagosDetalleVue :periodo_id="periodo_id"/>
      </div>
    </vs-popup>
  </div>
</template>

<script>
const ReportePagosDetalleVue = () => import('./ReportePagosDetalle.vue');
export default {
  components:{
    ReportePagosDetalleVue
  },
  data() {
    return{
      datosReport:'',
      totalPagos:0,
      totalPagosCerrar:0,
      abrir: false,
      popupMostrarDetalles:false,
      showTable: true,
    }
  },
  props:{
    periodo_id:{
      type:Number,
      default:0
    },
  },
  mounted(){
    let me = this
  },
  methods:{
    // getReporte(){
    //   let me = this
    //   this.$http.get(this.$server_url+`pedigo_Pagos?getTotalDocumentosLiq=1&idPeriodo=${me.periodo_id}`)
    //     .then(function (res) {
    //       if(res.data.status == 0){
    //         me.$vs.notify({
    //         text:'No se encontro datos',
    //         color:'warning',
    //         iconPack: 'feather',
    //         icon:'icon-check'})
    //         return
    //       }
    //       me.datosReport = res.data[0]
    //       const { totalAnticipos,  totalLiquidaciones, totalOtrosValores,totalConvenio, totalAnticipoAprobado, totalAnticiposSinCerrar, totalLiquidacionesSinCerrar, totalOtrosValoresSinCerrar, totalConvenioSinCerrar, totalAnticipoAprobadoSinCerrar }  = me.datosReport
    //       me.totalPagos = totalAnticipos + totalLiquidaciones + totalOtrosValores + totalConvenio + totalAnticipoAprobado
    //       me.totalPagosCerrar = totalAnticiposSinCerrar + totalLiquidacionesSinCerrar + totalOtrosValoresSinCerrar + totalConvenioSinCerrar + totalAnticipoAprobadoSinCerrar
    //     })
    //     .catch(function (error) {
    //         console.log(error + ' error');
    //     })
    // },
    getReporte() {
      let me = this
      me.$vs.loading();
      this.$http.get(this.$server_url + `pedigo_Pagos?getTotalDocumentosLiq=1&idPeriodo=${me.periodo_id}`)
        .then(function (res) {
          me.$vs.loading.close();
          if (res.data.status == 0) {
            me.$vs.notify({
              text: 'No se encontraron datos',
              color: 'warning',
              iconPack: 'feather',
              icon: 'icon-check'
            })
            return
          }

          me.datosReport = res.data[0]

          // separar pagos y cerrar
          me.totalPagos = 0
          me.totalPagosCerrar = 0

          for (let key in me.datosReport) {
            const value = Number(me.datosReport[key]) || 0
            if (key.endsWith("SinCerrar")) {
              me.totalPagosCerrar += value
            } else {
              me.totalPagos += value
            }
          }

          // redondear a 2 decimales si quieres
          me.totalPagos = parseFloat(me.totalPagos.toFixed(2))
          me.totalPagosCerrar = parseFloat(me.totalPagosCerrar.toFixed(2))
          // si total pagos es 0 y total pagos cerrar es 0, mostrar notificación
          if (me.totalPagos === 0 && me.totalPagosCerrar === 0) {
            me.$vs.notify({
              text: 'No se encontraron datos de pagos',
              color: 'warning',
              iconPack: 'feather',
              icon: 'icon-check'
            })
          }
        })
        .catch(function (error) {
          me.$vs.loading.close();
          console.log(error + ' error');
          me.$vs.notify({
            text: 'Error al cargar datos',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        })
    }

  }
}
</script>
